// @ts-ignore
import { GeoJsonLayer } from "@deck.gl/layers";
import { getDeckMapFillColor, getDeckStrokeColor, getDeckStrokeWeight, hexToRGBA, removeParentFeature } from "../../helpers";

export const GeoJSONLayer = ({
    geoJSON,
    selectedGeo,
    selectedTab,
    poiColors,
    cifType,
    isChecked,
    onHover,
    onClick,
    focusedItem,
    isGeoFocused,
    overlayCount,
    catchment,
    selAggLayer,
}: any) => {

    if (!geoJSON || !geoJSON.features?.length) return null;

    // Filter out hexagons - they will be rendered by H3HexagonLayer
    const nonHexagonGeoJSON = {
        ...geoJSON,
        features: geoJSON.features.filter((feature: any) => {
            const geoValue = feature.properties?.geoValue;
            return geoValue !== 'hex';
        })
    };

    // If after filtering there are no features left, return null
    if (!nonHexagonGeoJSON.features?.length) return null;

    const totalOverlayCount = Object.values(overlayCount || {}).reduce((acc: number, item) => acc + (item as number), 0);

    const getColor = (geoId: any) => {
        const defaultColor = ((!isChecked?.catchments || catchment) && totalOverlayCount >= 1) ? '#BEBEBE' : '#FFFFFF';
        return cifType.length > 0 && poiColors?.colorProperties?.length > 0 ?
            poiColors.colorProperties.find((item: any) => item.geoId === geoId || item.hexGeoId === geoId)?.color || defaultColor : defaultColor;
    };

    const getFillColor = (geoLevel: string, geoId: number) => {
        const color: [string, number] = getDeckMapFillColor(selectedGeo, selectedTab, geoLevel, getColor(geoId), isChecked?.subregionBoundaries, cifType.length, catchment, totalOverlayCount);
        // When hexagons are visible, use transparent fill to keep layer pickable for hover events
        if (selAggLayer === null || selAggLayer?.key === 'hexgrid') {
            return [0, 0, 0, 0]; // Fully transparent but still pickable
        }
        // When no CIF types are selected, show transparent instead of white
        if (cifType.length === 0) {
            return [0, 0, 0, 0];
        }
        return hexToRGBA(color[0], !catchment && isChecked?.catchments && color[1] !== 0 || (selectedGeo?.sub_district || catchment) && localStorage.getItem("map-style") == "hybrid" ? 100 : color[1]);
    }

    return new GeoJsonLayer({
        id: `geojson-layer-${geoJSON?.rootProperties?.geoId || "default"}`,
        data: removeParentFeature(nonHexagonGeoJSON, selectedGeo, selectedTab, catchment),
        stroked: true,
        filled: true, // Keep filled but use transparent color when hexagons are shown
        widthUnits: "pixels",
        lineWidthUnits: "pixels",
        pickable: true,
        autoHighlight: !isChecked?.subregionBoundaries && (catchment || (selectedGeo?.sub_district && !selectedGeo?.village)) ? false : true,
        highlightColor: [255, 255, 255, 50],
        getFillColor: (d: any) => {
            // Handle both old structure (geoId, geoLevel) and new structure (hexGeoId, geoValue)
            const geoId = d.properties.hexGeoId || d.properties.geoId;
            const geoLevel = d.properties.geoValue || d.properties.geoLevel;
            return getFillColor(geoLevel, geoId);
        },
        getLineColor: (d: any) => {
            const geoLevel = d.properties.geoValue || d.properties.geoLevel;
            return getDeckStrokeColor(selectedGeo, geoLevel, d.properties.is_adjacent, catchment, isChecked?.subregionBoundaries);
        },
        getLineWidth: (d: any) => {
            const geoId = d.properties.hexGeoId || d.properties.geoId;
            const geoLevel = d.properties.geoValue || d.properties.geoLevel;
            return getDeckStrokeWeight(selectedGeo, selectedTab, geoLevel, geoId, d.properties.is_adjacent, isChecked?.subregionBoundaries, catchment);
        },
        onHover: (info: any) => onHover(info),
        onClick: (info: any) => onClick(info),
        updateTriggers: {
            getFillColor: [poiColors?.colorProperties, selectedGeo, selectedTab, cifType, totalOverlayCount, catchment, isChecked?.subregionBoundaries, selAggLayer],
            getLineColor: [selectedGeo, selectedTab],
            getLineWidth: [selectedGeo, selectedTab, isChecked?.subregionBoundaries, catchment],
        },
    });
};
